import styled from 'styled-components';
import { Row as AntRow, Col as AntCol } from 'antd';

/* Row principal do filtro */
export const RowPrincipal = styled(AntRow)`
  display: flex;
  align-items: center;
  margin-top: 32px;
  margin-bottom: 18px;
`;

/* Col do filtro simples (Search) */
export const ColFiltroSimples = styled(AntCol)`
  display: flex;
  justify-content: center;
  align-items: center;
`;

/* Col da Busca Avançada */
export const ColBuscaAvancada = styled(AntCol)`
  display: flex;
  flex-direction: column;
  min-width: 170px;
`;

/**
 * Wrapper da periodicidade. Select nativo (WCAG); display: contents mantém Cols no Row.
 */
export const WrapperPeriodicidadeMobile = styled.div`
  display: contents;

  select {
    width: 100%;
    color: #000;
    box-sizing: border-box;
  }

  @media (max-width: 1200px) {
    select {
      min-height: 44px;
      padding: 6px 11px;
    }
  }
`;

/* Col dos botões Filtros/Ordenação da grid (desktop) */
export const ColBotoesGrid = styled(AntCol)`
  display: flex;
  flex-direction: column;
  min-width: 185px;
`;

/* Wrapper dos botões Filtros da grid / Ordenação da grid */
export const BotoesGridWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
`;

/* Wrapper do ícone nos botões da grid (alinhamento) */
export const BotaoGridIcone = styled.span`
  position: relative;
  top: 1px;
`;

/* Wrapper do botão para display inline-flex */
export const BotaoGridWrap = styled.span`
  display: inline-flex;
  align-items: center;
`;

/* Conteúdo dos popovers (Filtros / Ordenação) */
export const PopoverContent = styled.div`
  min-width: 320px;
`;

export const PopoverLista = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const PopoverItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const PopoverItemIndice = styled.span`
  width: 18px;
  text-align: right;
  display: inline-block;
`;

export const PopoverItemConteudo = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const PopoverItemValor = styled.span`
  display: block;
  max-width: 240px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PopoverItemAcoes = styled.div`
  margin-left: auto;
`;

export const PopoverFooter = styled.div`
  padding-top: 8px;
`;

export const PopoverEmpty = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

/* Ordenação: wrapper do label (Crescente/Decrescente) com ícone */
export const OrdenacaoItemLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
`;

export const OrdenacaoItemIconeWrap = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
`;

/** Label visível + select (WCAG 2.5.3 / label_02 — não depender só de aria-label). */
export const SelectField = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 4px;
  width: 100%;
`;

export const SelectLabel = styled.label`
  font-size: 13px;
  font-weight: 600;
  line-height: 1.3;
  color: #262626;
`;
